// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_kRd","cls2":"common-cls2_Wu0 common-cls1_kRd"};